// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'play-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2 2.606v12.771c0 .632.488 1.123 1.114 1.123.21 0 .349-.07.488-.14l11.84-6.386c.558-.28.697-.982.419-1.473-.07-.211-.279-.351-.418-.421L3.602 1.623c-.488-.28-1.184-.07-1.463.491-.07.14-.139.28-.139.491z'
  />
);

export const viewBox = '0 0 18 18';
